import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import { devicesDeviceMloSelector, devicesDeviceSupportsMloSelector, devicesMloChange } from 'modules/devices/slice';
import { linksLinkIsMeshSelector } from 'modules/links/slice';
import { trackEvent } from 'utils/googleAnalytics';

import MLOCheckbox, { MLOCheckboxProps } from '../components/elements/MLOCheckbox';
import MLOCheckboxInfoText from '../components/elements/MLOCheckboxInfoText';

const MLOCheckboxContainer = (props: Partial<MLOCheckboxProps>) => {
  const { leftId, linkId, rightId } = useBottomPanel();

  const mloSupported = useSelector((state) => leftId && devicesDeviceSupportsMloSelector(state, leftId));

  const clientSupportsMlo = useSelector((state) => rightId && devicesDeviceSupportsMloSelector(state, rightId));

  const checked = useSelector((state) => (leftId ? devicesDeviceMloSelector(state, leftId) : undefined));

  const linkIsMesh = useSelector((state) => (linkId ? linksLinkIsMeshSelector(state, linkId) : false));

  const dispatch = useDispatch();

  const onChange = useCallback(
    (mlo: boolean) => {
      if (leftId) {
        dispatch(devicesMloChange({ id: leftId, mlo }));
        trackEvent('bottomPanelMloChange', { mlo: mlo.toString() });
      }
    },
    [dispatch, leftId]
  );

  if (!mloSupported) {
    return null;
  }

  const label = 'MLO';

  const infoIndicatorSeverity = clientSupportsMlo ? 'info2' : 'warning';

  if (linkIsMesh) {
    return null;
  }

  return (
    <MLOCheckbox
      checked={!!checked}
      disabled={!clientSupportsMlo}
      onChange={onChange}
      label={label}
      infoIndicatorSeverity={infoIndicatorSeverity}
      infoText={<MLOCheckboxInfoText clientSupportsMlo={!!clientSupportsMlo} />}
      {...props}
    />
  );
};

export default MLOCheckboxContainer;
